import { render } from "./Services.vue?vue&type=template&id=29affc0d&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=29affc0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29affc0d"

export default script